import { createFileRoute } from '@tanstack/react-router'
import { PlatformProfilePage } from '../../../features/platform/profile-page'

export const Route = createFileRoute('/platform/_console/profile')({
  component: PlatformProfilePage,
})
